import { render } from "./homeFooter.vue?vue&type=template&id=4bfd6177&scoped=true"
const script = {}

import "./homeFooter.vue?vue&type=style&index=0&id=4bfd6177&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfd6177"]])

export default __exports__